import { PaginationParams } from "lib/types/sources.types";
import { apiRequest } from "./Api";

export const createNewAppointment = (data?: any) =>
  apiRequest<any, unknown>("POST", "appointment/store", data);

export const getAppointments = (params?: any) =>
  apiRequest<any, any>("GET", "appointment/own", null, undefined, params);

export const getAppointmentsById = (id?: any) =>
  apiRequest<any, any>("GET", "appointment/id", null, undefined, id);

export const getAssignedAppointments = (params?: any) =>
  apiRequest<any, any>("GET", "appointment/assigned", null, undefined, params);

export const getUnAssignedAppointments = (params?: any) =>
  apiRequest<any, any>("GET", "appointment/unassigned", null, undefined, params);

export const updateAppointment = (id: string, data?: any) =>
  apiRequest<any, any>("PUT", `appointment/update/${id}`, data);

export const requestForWonFeedback = (data: Record<string, any>) =>
  apiRequest<any, any>("POST", `appointment/feedback/won`, data);

export const requestForPendingFeedback = (data: Record<string, any>) =>
  apiRequest<any, any>("POST", `appointment/feedback/pending`, data);

export const requestForFollowUp = (data: Record<string, any>) =>
  apiRequest<any, any>("POST", `appointment/feedback/follow-up`, data);

export const requestForLost = (data: Record<string, any>) =>
  apiRequest<any, any>("POST", `appointment/feedback/lost`, data);

export const uploadAppointmentFile = (data: Record<string, any>) =>
  apiRequest<any, any>("POST", "appointment/document/upload", data);

export const deleteAppointmentDocument = (data: any) =>
  apiRequest<any, any>(
    "DELETE",
    `appointment/document/delete/${data.document_id}`,
    data
  );

export const getActivityLog = (params: any) =>
  apiRequest<any, any>("GET", "appointment/logs", null, undefined, params);

export const assignTo = (data: any) =>
  apiRequest<any, any>("POST", `appointment/assign`, data);

export const getAssigned = (params: any) =>
  apiRequest<any, any>("GET", "appointment", null, undefined, params);

export const getNotAssigned = (params: any) =>
  apiRequest<any, any>("GET", "appointment", null, undefined, params);

export const getNotAssignedDigital = (params: any) =>
  apiRequest<any, any>("GET", "appointment", null, undefined, params);

export const switchAppointment = (data: any) =>
  apiRequest<any, any>("POST", "appointment/switch", data);

export const uploadAppointmentFileManually = (data: any) =>
  apiRequest<any, any>("POST", "appointment/import/store-import-file", data, {
    "content-type": "multipart/form-data",
  });

export const dataOfCsv = (data: any) =>
  apiRequest<any, any>("POST", "appointment/import/csv-data", data);

export const storeUploadedAppointment = (data: any) =>
  apiRequest<FormData, any>("POST", "appointment/import/store", data);

export const returnAppointmentToList = (data: any) =>
  apiRequest<FormData, any>("POST", "appointment/unassign", data);

export const getStatisticCardsData = () =>
  apiRequest<any, any>("GET", "appointment/statistic/info-card");

export const getAppointmentDocument = (params?: any) =>
  apiRequest<any, any>("GET", "appointment/document", null, undefined, params);

export const getAppointmentNotes = (params?: any) =>
  apiRequest<any, any>("GET", "appointment/notes", null, undefined, params);

export const createNewAddress = (data: any) =>
  apiRequest<FormData, any>("POST", "appointment/address/store", data);

export const sendAppointmentNote = (data: { appointment_id: number, note: string, image?: string }) =>
  apiRequest<{ appointment_id: number, note: string, image?: string }, any>('POST', 'appointment/add-notes', data)

export const getAppointmentSource = (params?: any) =>
  apiRequest<any, any>("GET", "appointment/source", null, undefined, params);

export const createAppointmentTask = (data: any) =>
  apiRequest<FormData, any>("POST", "appointment/pending/store", data);

export const deleteAppointment = (id: any) =>
  apiRequest<any, any>("DELETE", `appointment/delete/${id}`);

export const exportAppointment = (params: any) => {
  return apiRequest<FormData, any>("POST", `appointment/export-appointments`, params, undefined, undefined, 'blob');
};


//////Appointment Source API Calls
export const createNewAppSource = (data?: any) =>
  apiRequest<any, unknown>("POST", "appointment/sources/store", data);

export const getAppSources = (params?: PaginationParams) =>
  apiRequest<any, any>("GET", "appointment/sources", null, undefined, params);

export const updateAppSourceStatus = (params: any) => {
  return apiRequest<FormData, any>("POST", `appointment/sources/change-status`, params, undefined);
};

export const DeleteAppSourceById = (id: any) => {
  return apiRequest<FormData, any>("DELETE", `appointment/sources/delete/${id}`);
};

export const updateAppSource = (params: any) => {

  return apiRequest<FormData, any>("PUT", `appointment/sources/edit/${params.id}`, params, undefined);
};

export const getAllAppSources = () =>
  apiRequest<any, any>("GET", "appointment/sources/for-filter");

export const getImportAppSources = () =>
  apiRequest<any, any>("GET", "appointment/sources/import-for-filter");

////////////

